export class StorageUtil {

  static get userID(): number {
    return +localStorage.getItem('userId');
  }

  static get clubID(): number {
    return +localStorage.getItem('clubId');
  }

  static set clubID(id: number) {
    localStorage.setItem('clubId', id.toString());
  }

  static get sClubID(): number {
    return +sessionStorage.getItem('s-clubId');
  }

  static set sClubID(id: number) {
    sessionStorage.setItem('s-clubId', id.toString());
  }

  static get sClubProgramTypeID(): number {
    return +sessionStorage.getItem('s-clubProgramTypeID');
  }

  static set sClubProgramTypeID(id: number) {
    sessionStorage.setItem('s-clubProgramTypeID', id.toString());
  }

  static get teamId(): number {
    return +localStorage.getItem('teamId');
  }

  static get teamGender() {
    return localStorage.getItem('pg');
  }

  static set teamId(id: number) {
    localStorage.setItem('teamId', id.toString());
  }

  static get roleId(): number {
    return +localStorage.getItem('roleId');
  }

  static set params(data) {
    localStorage.setItem('old-param', JSON.stringify(data));
  }

  static get oldParams() {
    const oldParam = localStorage.getItem('old-param');
    return oldParam ? JSON.parse(oldParam) : {};
  }

}



// WEBPACK FOOTER //
// ./src/app/models/utils/storage.util.ts